export const SET_PROPERTY = 'SET_PROPERTY';
export const GET_IMAGES = 'GET_IMAGES';
export const UPDATE_IMAGES = 'UPDATE_IMAGES';
export const UPLOAD_IMAGES = 'UPLOAD_IMAGES';
export const GET_ID_VEHICLE = 'GET_ID_VEHICLE';
export const GET_VEHICLE_BY_ID = 'GET_VEHICLE_BY_ID';
export const RESET_VEHICLE_INFORMATION = 'RESET_VEHICLE_INFORMATION';
export const UPDATE_CAMPAIGN_IMAGES = 'UPDATE_CAMPAIGN_IMAGES';
export const GET_CAMPAIGNS_ID = 'GET_CAMPAIGNS_ID';
export const UPDATE_MASSIVE = 'UPDATE_MASSIVE';
